import React from "react";

import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../Shared/Styles/ContainerStyles";
import Paper from "@material-ui/core/Paper";
import NewTable from "../../Shared/Components/Table/NewTable";
import TableStatusIndicator from "../../Shared/Components/Table/TableStatusIndicator";
import UploadIcon from "@material-ui/icons/CloudUpload";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import GroupIcon from '@material-ui/icons/Group';
import SendIcon from "@material-ui/icons/Send";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import DownloadDialog from "../../Shared/Components/Download/DownloadDialog";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import ConfirmAlert from "../../Shared/Components/Confirm/ConfirmAlert";
import ContactDetail from "./ContactDetail";
import Fab from "@material-ui/core/Fab";
import Add from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";

import {
  dateCellDataGetter,
  contactTypeDataGetter,
  booleanCellDataGetter,
  getCountURLFromFilters,
  getInfiniteURLFromFilters,
  nestedSort,
} from "../../Shared/Components/Table/TableUtilities";

import api from "../../Shared/Functions/APIHelpers";

const initialState = {
  detailDialogOpen: false,
  contactDetail: {},

  //FOR TABLE
  tableData: [],
  recordCount: 0,
  dataURL: "broker-contact-mewa",
  staticFilterURL: "broker-contact-mewa-static-filter",
  staticFilters: ["is_primary"],
  staticFilterValues: [],
  sortBy: "",
  sortDirection: "ASC",
  countURL: "broker-contact-mewa-count",
  initialCount: "--",
  currentCount: "--",
  activeFilters: [],
  fetching: false,
  initialLoadDone: true,
  closeMenu: null,

  /*state for confirm alert */
  confirmAlertTitle: "",
  confirmAlertText: "",
  confirmAlertOpen: false,
  doFunc: null,
  doNotFunc: null,
};

class ContactContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  reset() {
    this.setState(initialState);
  }

  componentDidMount() {
    this.handleInitialData(true);
  }

  handleInitialData = (isInitial) => {
    this.setState({ initialLoadDone: false, fetching: true }, () => {
      this.getStaticFilterValues().then((values) => {
        this.setState({ staticFilterValues: values }, () => {
          this.getTableCount().then((count) => {
            this.getTableData(0, 10)
              .then((r) => {
                this.setState({
                  tableData: r,
                  recordCount: count["record_count"],
                  fetching: false,
                  initialLoadDone: true,
                });
                //if this is the first time the page is mounted, set record count as initial table amount
                //else set the current filtered count
                if (isInitial)
                  this.setState({
                    initialCount: count["record_count"],
                    currentCount: count["record_count"],
                  });
                else this.setState({ currentCount: count["record_count"] });
              })
              .catch((err) => {
                if (err === 403) {
                  this.props.history.push("/mewa-admin/auth?error=5");
                }
                if (err === 400) {
                  this.props.enqueueSnackbar(
                    "Something went wrong rendering contacts",
                    {
                      variant: "error",
                    }
                  );
                }
              });
          });
        });
      });
    });
  };

  loadMoreRows = ({ startIndex, stopIndex }) => {
    if (this.state.fetching) return;
    this.setState({ fetching: true }, () => {
      return new Promise((resolve, reject) => {
        this.getTableData(startIndex, stopIndex)
          .then((r) => {
            var currentData = this.state.tableData;
            var newData = [...currentData, ...r];
            this.setState({ tableData: newData, fetching: false }, () => {
              resolve(newData);
            });
          })
          .catch((err) => {
            if (err === 403) {
              this.props.history.push("/mewa-admin/auth?error=5");
            }
            if (err === 400) {
              this.props.enqueueSnackbar(
                "Something went wrong rendering Contacts",
                {
                  variant: "error",
                }
              );
            }
          });
      });
    });
  };

  getTableCount = () => {
    return new Promise((resolve, reject) => {
      resolve(
        api.getTableCount(
          getCountURLFromFilters(this.state.activeFilters, this.state.countURL)
        )
      );
    });
  };

  getTableData = (startIndex, stopIndex) => {
    return new Promise((resolve, reject) => {
      resolve(
        api.getTableData(
          getInfiniteURLFromFilters(
            this.state.activeFilters,
            this.state.dataURL,
            startIndex,
            stopIndex,
            this.state.sortBy,
            this.state.sortDirection,
            ""
          )
        )
      );
    });
  };

  getStaticFilterValues = () => {
    return new Promise((resolve, reject) => {
      resolve(
        api.getStaticFilterValues(
          this.state.staticFilterURL,
          JSON.stringify({ filters: this.state.staticFilters })
        )
      );
    });
  };

  setActiveFilters = (filters) => {
    this.setState({ activeFilters: filters }, () => {
      this.handleInitialData();
    });
  };

  sortTable = (sortBy, sortDirection, col) => {
    this.setState({ sortBy: sortBy, sortDirection: sortDirection }, () => {
      this.handleInitialData();
    });
  };

  handleViewContactTeam = (selectedItem, closeMenu) => {
    this.setState({ detailDialogOpen: true, contactDetail: selectedItem });
    closeMenu();
  };

  getActionMenuItems = (selectedItem, closeMenu) => {
    const { classes } = this.props;
    return (
      <div>
        <MenuItem
          onClick={() => {
            this.handleViewContactTeam(selectedItem, closeMenu);
          }}
        >
          <GroupIcon className={classes.leftIcon} />
          View Team
        </MenuItem>
      </div>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <ConfirmAlert
          isOpen={this.state.confirmAlertOpen}
          isNo={this.state.doNotFunc}
          isYes={this.state.doFunc}
          AlertTitle={this.state.confirmAlertTitle}
          AlertText={this.state.confirmAlertText}
        />
        <ContactDetail
          Open={this.state.detailDialogOpen}
          Close={() => {
            this.setState({
              detailDialogOpen: false,
              contactDetail: {},
            });
          }}
          enqueueSnackbar={this.props.enqueueSnackbar}
          contactDetail={this.state.contactDetail}
        />

        <div className={classes.containerRoot}>
        <div className={classes.containerTitle}>Broker Contacts</div>
          <div className={classes.containerContent}>
            <Paper className={classes.containerPaper}>
              <NewTable
                enqueueSnackbar={this.props.enqueueSnackbar}
                loaded={this.state.initialLoadDone}
                loadedData={this.state.tableData}
                sortBy={this.state.sortBy}
                sortDirection={this.state.sortDirection}
                sortTable={this.sortTable}
                staticFilterValues={this.state.staticFilterValues}
                recordCount={this.state.recordCount}
                loadMoreRows={this.loadMoreRows}
                setActiveFilters={this.setActiveFilters}
                activeFilters={this.state.activeFilters}
                tableName={"Broker Contacts"}
                columns={[
                  {
                    label: "First Name",
                    dataKey: "first_name",
                    width: 300,
                    flexGrow: 0,
                    hasFilter: false,
                  },
                  {
                    label: "Last Name",
                    dataKey: "last_name",
                    width: 300,
                    flexGrow: 2,
                    hasFilter: false,
                  },
                  {
                    label: "Agent ID",
                    dataKey: "carrier_agent_id",
                    width: 300,
                    flexGrow: 2,
                    hasFilter: false,
                  },
                  {
                    label: "Email",
                    dataKey: "email",
                    hasFilter: true,
                    filterType: "Search",
                    width: 300,
                    flexGrow: 0,
                  },
                  {
                    label: "Type",
                    dataKey: "is_primary",
                    cellRenderer: contactTypeDataGetter,
                    hasFilter: false,
                    width: 300,
                    flexGrow: 0,
                  },
                ]}
                actionMenuItems={this.getActionMenuItems}
              />
            </Paper>
            <div id="tableStatus" style={{ display: "flex" }}>
              <div
                id="tableStatusIndicator"
                style={{
                  flexGrow: "1",
                  textAlign: "right",
                  marginRight: 0,
                  marginTop: 20,
                }}
                color="primary"
              >
                <TableStatusIndicator
                  initialCount={this.state.initialCount}
                  currentCount={this.state.currentCount}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ContactContainer);
